import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoans } from "../api/hooks/useLoan";
import CustomButton from "../components/customButton";
import LoanCard from "../components/loanCard";
import EmptyList from "../components/emptyList";
import Loader from "../components/loader";

const LoanCenter = () => {
  const [loans, setLoans] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState();
  const [balance, setBalance] = useState(0);
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");

  const navigate = useNavigate();

  const { data: loantData, isLoading: isLoanLoading, error: loanError } = useLoans()

  useEffect(() => {
    if (!loantData) return;

    setLoans(loantData.data);

  }, [loantData]);

  return (
    <div className="min-h-screen bg-gray-50 p-6 items-center">
      {/* Header */}
      <header className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold text-gray-800">Loan Center</h1>
        <CustomButton fullWidth={false} label={"Request New Loan"} onPress={() => navigate('/book-loan')} />
      </header>

      {/* Balance Card */}
      {loans.length > 0 && <div className="p-6 grid gap-4 md:grid-cols-2">
        {loans.map((loan) => (
          <LoanCard key={loan.id} loan={loan} />
        ))}
      </div>}
      {loans.length == 0 && !isLoanLoading && !loanError && <div className="flex items-center justify-center p-6 gap-4">
        <EmptyList message="No Loans founds" />
      </div>}

      {isLoanLoading && <Loader />}
    </div>
  );
};

export default LoanCenter;